import Vue from 'vue';
import Vuex from 'vuex';

import auth from './auth.module';
import my from './my.module';
import search from './search.module';
import common from './common.module';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    my,
    search,
    common,
  }
});